import { AbstractRoute } from '@/core/lib/router/route';

class NotificationPushRoute extends AbstractRoute {
  static path = '';

  getPath() {
    return NotificationPushRoute.path;
  }

  private href: string;

  static isPrivate = false;

  public isExternal = true;

  constructor(notificationPushPath: string) {
    super();

    this.href = notificationPushPath;
  }

  isPrivate() {
    return NotificationPushRoute.isPrivate;
  }

  resolve() {
    return this.href;
  }

  clone(): NotificationPushRoute {
    return this;
  }
}

export default { NotificationPushRoute };
